import Header from "../../../../Components/Header/Header";
import Sidebar from "../../../../Components/Sidebar/Sidebar";
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../Helper/Context";
import { DailyPreventiveWorkTableDataAPI } from "../../../../Redux/GardenDashboardSlice/DailyPreventiveWorkSlice";
import ViewURL from "../../../../Components/ViewURL/ViewURL";
import { Pegination } from "../../../../Components/Pegination/Pegination";
import { WardNameDataDDL } from "../../../../Components/CommonDDL/WardNameDataDDL";
import { WardNameDDLAPI } from "../../../../Redux/DDLSlice";
import moment from "moment";
import { Loading } from "../../../../Helper/Loading";
import { WorkTypeDDL } from "../../../../Components/CommonDDL/WorkTypeDDL";
import { PreventiveWorkReportTableDataAPI } from "../../../../Redux/ReportsSlice/PreventiveWorkReportSlice";
import { PreventiveWorkReportExport } from "./PreventiveWorkReportExport";
import { toastErrorr } from "../../../../Helper/ToastMessage";

export default function PreventiveWorkReport() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")

    // console.log(ApiFlag)

    const d = new Date();
    let month = d.getMonth();

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '1',
        Label: WLable && WLable ? WLable : "Select...",
    })
    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })


    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [ImageHeading, setImageHeading] = useState('')
    const [PDFUrl, setPDFUrl] = useState('')

    const [PopUpField, setPopUpField] = React.useState({
        addPopUp: false,
        deletePopUp: false,
        popupFlag: '',
        popupBtn: "",
        apiFlag: "",
        rowData: ''
    })



    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))
        setWardName({
            ...WardName,
            ID: WardName.DDL[0].value,
            Label: WardName.DDL[0].label,
        })
        setWorkType({
            ...WorkType,
            ID: 0,
            Label: 'Select...',
        })

        // console.log("call")
    }

    const handleGetPDFUrl = (pdfUrl) => {
        if (pdfUrl && pdfUrl != '') {
            setPDFUrl(pdfUrl)
        } else {
            toastErrorr("PDF not found")
        }
    }

    const handleOpenPdf = () => {
        window.open(PDFUrl)
    }


    const handlePost = () => {
        setIsPost(!IsPost)
    }

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }
    useEffect(() => {
        const data = {
            M_ProjectID: '0',
            M_WorkSubTypeID: WorkType.ID,
            M_WardID: WardName.ID,
            FromDate: FromDate,
            ToDate: ToDate,
            UserID: UserID,
            token: token,
            handleGetPDFUrl: handleGetPDFUrl
        }
        // if (WardName.ID !== 0) {
        dispatch(PreventiveWorkReportTableDataAPI({ data }))
        // }

    }, [IsPost, To, IsClear, isSearch])

    const { tableData, isLoading } = useSelector(state => state.PreventiveWorkReportTableData)

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    return (
        <>
            {isLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId} active='preventiveWorkReport' />
                    <div id="" className="content1 content">
                        <div className="data_mob">
                            <div className="row m-1 pb-4 master_border">
                                <div className="col-8">
                                    <h5 className="ps-1 py-2">Preventive Work Report</h5>
                                </div>
                                <div className="col-4 mt-2">
                                    <PreventiveWorkReportExport
                                        name='Preventive Work Report'
                                        ExcelData={tableData}
                                        WardName={WardName}
                                        FromDate={FromDate}
                                        ToDate={ToDate}
                                    />

                                    {/* <button type="button" className="btn btn-outline-primary float-end mr-1 mb-2 pt-1 pb-1 pl-3 pr-3"
                                        onClick={handleOpenPdf}
                                    >PDF</button> */}
                                    <button type="button" className="btn btn-danger float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                                        onClick={handleOpenPdf}
                                    ><i className='fas fa-file-pdf mx-2'></i>PDF</button>
                                </div>
                                <div className="row m-0">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                        <div className="col-12">
                                            <div className="row py-1 rounded2">
                                                <div className="col-12 col-md-4 col-lg-2">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"> <b>From Date :</b></label>
                                                        <input type="date"
                                                            className="form-control"
                                                            id="FromDate"
                                                            value={FromDate}
                                                            onChange={(e) => setFromDate(e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-2">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"><b>To Date :</b></label>
                                                        <input type="date"
                                                            className="form-control"
                                                            id="ToDate"
                                                            value={ToDate}
                                                            onChange={(e) => setToDate(e.target.value)} />

                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        // HWard={HWard}
                                                        // WLable={WLable}
                                                        Flag='Ward'
                                                    />
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-2">
                                                    <WorkTypeDDL
                                                        WorkType={WorkType}
                                                        setWorkType={setWorkType}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-3 col-lg-2 mt-lg-4 mt-md-4 d-md-flex" >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button>
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                            </div>

                                            <div className="row mob_table table-responsive pt-1">
                                                <table
                                                    id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Sector Name	 </th>
                                                            <th>Work Name</th>
                                                            <th>Assigned Date</th>
                                                            <th>Asset Name</th>
                                                            <th>Upload Date</th>
                                                            {/* <th>Work Sub Type</th>
                                                            <th>Before Work <br />Photo</th>
                                                            {
                                                                searchName == 'Completed' ?
                                                                    <th>After Work <br />Photo</th>
                                                                    :
                                                                    <></>
                                                            } */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item, i) =>
                                                                <tr>
                                                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : i + 1}</td>
                                                                    <td>{item.sectorname ? item.sectorname : '-'}</td>
                                                                    <td>{item.workName ? item.workName : '-'}</td>
                                                                    <td>{item.uploadDate ? item.uploadDate : '-'}</td>
                                                                    <td>{item.assetName ? item.assetName : '-'}</td>
                                                                    <td>{item.uploadDate ? item.uploadDate : '-'}</td>


                                                                </tr>
                                                            ) :
                                                                <td colSpan={15}>No data found</td>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {
                    showImagePopup ?
                        <ViewURL
                            Heading={ImageHeading}
                            setshowImagePopup={setshowImagePopup}
                            ImagePopUpData={ImagePopUpData}

                        />
                        : ''


                }

            </div>

        </>

    )

}